<template>
  <div class="layout-container">
    <m-header><div slot="nav"></div></m-header>
    <div class="w">
      <div class="content">
        <div class="account-sidebar">
          <div class="avatar gray-box" style="margin-bottom: 10px; padding-top: 20px;padding-bottom: 20px;">
            <div>
              <img style="border-radius: 5px;" :src="user.avatar == ''?'/static/images/default.png':user.avatar">
              <p>
                <span class="label label-default"><i class="el-icon-s-custom"></i> 认证用户</span>
              </p>
            </div>
          </div>
          <div class=" gray-box ">
            <el-menu
                ref="sideMenu"
                :default-active="activeIndex"
                class="el-menu-demo"
                @select="handleSelect"
              >
              <template>
                <div v-for="item in navMenuData" :key="item.index">
                  <el-menu-item :index="item.index" v-if="!item.child && item.index=='desOrderList'"><i class="el-icon-menu"></i>1{{item.name}}</el-menu-item>
                  <!-- <el-menu-item :index="item.index" v-if="!item.child && item.index=='designer'&&user.userType=='10'"><i class="el-icon-s-order"></i>{{item.name}}</el-menu-item> -->
                  <el-menu-item :index="item.index" v-if="!item.child && item.index=='orderList'"><i class="el-icon-s-order"></i>{{item.name}}</el-menu-item>
                  <el-menu-item :index="item.index" v-if="!item.child && item.index=='addressList'"><i class="el-icon-position"></i>{{item.name}}</el-menu-item>
                  <el-menu-item :index="item.index" v-if="!item.child && item.index=='invoice'"><i class="el-icon-postcard"></i>{{item.name}}</el-menu-item>
                  <el-menu-item :index="item.index" v-if="!item.child && item.index=='support'"><i class="el-icon-download"></i>{{item.name}}</el-menu-item>
                  <el-menu-item :index="item.index" v-if="!item.child && item.index=='out'"><i class="el-icon-remove"></i>{{item.name}}</el-menu-item>
                  <el-submenu :index="item.index" v-if="item.child && item.index === 'designer' && user.userType === '10'">
                    <template slot="title"><i class="el-icon-user"></i>{{item.name}}</template>
                    <template>
                      <div v-for="item2 in item.child" :key="item2.index">
                        <el-menu-item :index="item2.index">{{item2.name}}</el-menu-item>
                      </div>
                    </template>
                  </el-submenu>
                  <el-submenu :index="item.index" v-if="item.child && item.index != 'designer' ">
                    <template slot="title"><i class="el-icon-user"></i>{{item.name}}</template>
                    <template>
                      <div v-for="item2 in item.child" :key="item2.index">
                        <el-menu-item :index="item2.index">{{item2.name}}</el-menu-item>
                      </div>
                    </template>
                  </el-submenu>
                </div>
              </template>
            </el-menu>
          </div>
        </div>
        <div class="account-content">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <m-footer></m-footer>
    <Customer class="customerSer"></Customer>
  </div>

</template>
<script>
  import MHeader from '/common/MHeader'
  import MFooter from '/common/MFooter'
  import { mapState } from 'vuex'
  import Customer from '../Order/components/customerSer'
  export default {
    data () {
      return {
        title: '我的订单',
        activeIndex: "movie",
        navMenuData: [
          {
            index: "2",
            name: "我的账户",
            child: [{ index: "information", name: "基本信息" },{ index: "money", name: "钱包管理" },{ index: "safeCenter", name: "安全设置" }]
          },
          // { index: "desOrderList", name: "我的设计单"},
          {
            index: "designer",
            name: "设计师管理",
            child: [{ index: "inviteDesigner", name: "邀约设计师" },{ index: "blockDesList", name: "拉黑设计师" },]
          },
          // { index: "orderList", name: "商城订单" },
          { index: "addressList", name: "收货地址" },
          // { index: "invoice", name: "发票管理" },
          { index: "support", name: "下载中心" },
          { index: "out", name: "退出登录" },
        ],
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      // 根据当前路由路径，找到应该展开的子菜单index
      getOpenedsByRoute () {
        const path = this.$route.path.replace('/user/', '');
        const opened = [];
        this.navMenuData.forEach(item => {
          if (item.child) {
            const match = item.child.find(c => c.index === path);
            if (match) {
              opened.push(item.index);
            }
          }
        });
        return opened;
      },
      updateMenuState () {
        this.activeIndex = this.$route.path.replace('/user/', '');
        const opened = this.getOpenedsByRoute();
        this.$nextTick(() => {
          if (this.$refs.sideMenu) {
            opened.forEach(idx => {
              this.$refs.sideMenu.open(idx);
            });
          }
        });
      },
      // 退出登陆
      _loginOut () {
        this.$api.post({
            url:'/logout',
            data:{
              token: getStore('token')
            }
        }).then(res => {
           this.$store.dispatch('user/logout');
           this.$yxz.msg('退出成功');
           this.$wanlshop.back(1);
        })
      },
      tab (e) {
        this.$router.push({path: '/user/' + e.path})
      },
      handleSelect(key, keyPath) {
        this.activeIndex = key;
        // 展开父级子菜单
        if (keyPath.length > 1 && this.$refs.sideMenu) {
          this.$refs.sideMenu.open(keyPath[0]);
        }
        // 退出登录单独处理
        if (key === 'out') {
          this._loginOut();
          return;
        }
        // 手动路由跳转
        this.$router.push('/user/' + key);
      }
    },
    watch: {
      '$route' () {
        this.updateMenuState();
      }
    },
    mounted(){
      this.updateMenuState();
    },
    components: {
      MHeader,
      MFooter,
      Customer
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../assets/style/mixin";
  .layout-container{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .w {
    padding-top: 10px;
    padding-bottom: 20px;
  }

  .content {
    display: flex;
    height: 100%;
  }

  .account-sidebar {

    width: 210px;
    border-radius: 6px;
    .avatar {
      // padding-top: 20px;
      border-radius: 8px;
      text-align: center;
      img {
        width: 108px;
        height: 108px;
      }
      h5 {
        font-size: 18px;
        line-height: 48px;
        font-weight: 700;
      }
    }
    .account-nav {
      // padding-top: 15px;
      li {
        position: relative;
        height: 48px;
        border-top: 1px solid #EBEBEB;
        line-height: 48px;
        &:hover {
          a {
            position: relative;
            z-index: 1;
            height: 50px;
            background-color: #98AFEE;
            line-height: 50px;
            color: #FFF;
          }

        }
        a {
          display: block;
        }
        &.current {
          a {
            position: relative;
            z-index: 1;
            height: 50px;
            background-color: #98AFEE;
            line-height: 50px;
            color: #FFF;
          }
        }
      }
    }
  }
  .account-content {
    margin-left: 20px;
    flex: 1;
  }
  .label {
      display: inline;
      padding: 0.2em 0.6em 0.3em;
      font-size: 75%;
      font-weight: 700;
      line-height: 1;
      color: #fff;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25em;
  }
  .label-default {
      background-color: red;
  }
  .customerSer{
    top: 50%;
  }
</style>



// WEBPACK FOOTER //
// user.vue?87c61d5a